import { cache } from '@/shared/utils/Cache';
import { getAutoLoginLegalContractRoute } from '../../config';

/** 因为运营商不支持自定义 协议点击跳转事件，使用m2域名可以新开Webview进行跳转 */
export const getCanNewWebviewUrl = (uri: string): string => {
  const baseUrl = `https://m2.hellobike.com${window.location.pathname}#`;

  return `${baseUrl}${uri}${uri.includes('?') ? '&' : '?'}source=${String(cache.get('source') || 'default')}`;
};

/**
 * 运营商一键登录弹窗自定义样式
 * 不支持使用vm自适应样式大小
 */
const customStyleConfig = {
  submitBtnStyle: {
    bgColor: '#ff5526',
    ifShow: true,
    high: '120px',
    height: '52px',
    fontSize: '18px',
    borderRadius: '6px',
    name: '本机号码一键登录',
  },
  checkBtnStyle: {
    checkedUrl: require('./images/auto-login/agree-checked@3x.png') as string,
    uncheckUrl: require('./images/auto-login/agree-unchecked@3x.png') as string,
    width: '16px',
    height: '16px',
  },
  agreeStyle: {
    left: '',
    fontSize: '12px',
    high: '66px',
    textalign: 'left',
    fontColor: '#879099',
    hrefColor: '#ff5526',
    agreeArr: [
      {
        name: '《用户协议及隐私政策》',
        url: `${getCanNewWebviewUrl(getAutoLoginLegalContractRoute())}`,
      },
    ],
  },
};

export default customStyleConfig;
